module.exports = __webpack_public_path__ + "img/title1.7054f154.png";